module.exports = __webpack_public_path__ + "static/media/jul1.fcc03e75.jpg";